
export const addHoursToDate = (date, hours) => {
  return new Date(new Date(date).setHours(date.getHours() + hours));
};

export const centsToEur = (cents) => cents / 100;